import React from 'react';

// @ts-ignore
import ModalBulkTaskType from "./bulk-action/update-task-type/task-type"
import ModalProjectConvertNew from "./project/convert/project-convert-new"
import projectConvert_checkDocumentAndConfirm from "./project/convert/functions/check-and-confirm-page-convert";
import {modalMoveMulti} from "./move-to/move"
import {modalCopyTasks} from "./copy/copy"
import SelectDate from "./select-date/select-date"
import {areCustomFieldsLocked, showCustomFieldsUpgrade} from "../fields3/render/custom-field-upgrade-guard"

export default class BulkModalsManager {

    constructor() {}

    updateTimeAllocation(callback:callback) {
        gd.modal.showForm({
            header: {
                title: 'Update Time Allocation'
            },
            component: require('./bulk-action/update-time-allocation/update-time-allocation'),
            params: {
                onSubmit: (result:any)=>{
                    if (callback) callback(result);
                    else gd.modal.hide();
                }
            }
        });
    }

    move(projects:any, tasks:any, onMoveCallback:callback) {
        return modalMoveMulti(projects, tasks, {
            callback: onMoveCallback,
        })
    }

    copyTasks(tasks:any, onCopyCallback:callback) {
        return modalCopyTasks(tasks, {
            callback: onCopyCallback,
        })
    }

    addTag(companyId:ID, arrTasks:any[], existingTags:any, callback:callback) {
        gd.modal.showV4({
            className: 'modal-tag',
            header: {
                title: 'Select Tag'
            },
            component: require('./tag/modal-tag'),
            params: {
                tasks       : arrTasks,
                companyId   : companyId,
                tags        : existingTags ? existingTags : [],
                callback    : callback
            }
        });
    }

    removeTag(companyId:ID, arrTasks:any[], existingTags:any, callback:callback) {
        gd.modal.showV4({
            className: 'modal-tag',
            header: {
                title: 'Remove Tag'
            },
            component: require('./tag/modal-tag'),
            params: {
                tasks       : arrTasks,
                companyId   : companyId,
                tags        : existingTags ? existingTags : [],
                removeOnly  : true,
                callback    : callback
            }
        });
    }

    schedule(buttons:any, callback:callback) {
        gd.modal.showGeneric({
            className: 'modal-action-deadline',
            header: {
                title: 'Schedule',
            },

            component: SelectDate,

            params: {
                onSubmit: (date:any, status:any)=>{
                    if (callback) callback(date, status);
                    gd.modal.hide();
                },
                this            : this,
                btnToday        : buttons.today,
                btnTomorrow     : buttons.tomorrow,
                btnSomeday      : buttons.someday,
                btnNoValue      : buttons.noValue,
                btnNoValueLabel : 'No schedule'
            }
        });
    }

    addCRMContacts(accountId:ID, contactIds:ID[], callback:callback) {
        gd.modal.showV4({
            className: 'modal-crm-search',
            component: require('./crm/search/search'),
            params: {
                type    : 'contact',
                accountId,  // for 'contact' type
                contactIds, // for 'contact' or 'remove-contact' type
                onSubmit: (crmAccountId:ID, crmContactIds:ID[])=>{
                    if (callback) callback(crmContactIds);
                    gd.modal.hide();
                },
            }
        })
    }

    removeCRMContacts(contactIds:ID[], callback:callback) {
        gd.modal.showV4({
            className: 'modal-crm-search',
            component: require('./crm/search/search'),
            params: {
                type    : 'remove-contact',
                contactIds, // for 'contact' or 'remove-contact' type
                onSubmit: (crmAccountId:ID, crmContactIds:ID[])=>{
                    if (callback) callback(crmContactIds);
                    gd.modal.hide();
                },
            }
        })
    }

    updateActionRequired(companyId:ID, projectId:ID|null, onSubmit:callback) {
        gd.modal.showForm({
            header: {
                title: 'Action Required by'
            },
            component: require('./bulk-action/update-action-required/action-required.jsx'),
            params: {
                noValueLabel: "No Action required",
                onSubmit: onSubmit,
                companyId: companyId,
                projectId: projectId
            }
        });
    }

    updateAssigned(companyId:ID, projectId:ID|null, onSubmit:callback) {

        gd.modal.showForm({
            header: {
                title: 'Assign to'
            },
            component: require('./bulk-action/update-action-required/action-required.jsx'),
            params: {
                noValueLabel: "Not Assigned",
                onSubmit: onSubmit,
                companyId: companyId,
                projectId: projectId
            }
        });
    }

    // manager -> app.manager
    updateTaskType(projectId:ID, manager:any, onSubmit:callback) {

        gd.modal.showForm({
            className: 'modal-bulk-task-type',
            header: {
                title: 'Select Task Type'
            },
            component: ModalBulkTaskType,

            params: {
                onSubmit: onSubmit,
                // companyId: gd.companyId,
                projectId: projectId, // not in use at the moment
                manager: manager,
            }
        });

    }

    async updateProjectType(projectIds:ID[], onConvertCallback:callback) {
        const result = await projectConvert_checkDocumentAndConfirm(projectIds)

        if (result) {
            gd.modal.showV4({
                className   : 'modal-project-convert',
                component   : ModalProjectConvertNew,
                params      : {
                    projectIds  : projectIds,
                    callback(values:any) {
                        gd.modal.hide()
                        if (onConvertCallback) onConvertCallback(values)
                    }
                }
            })
        }
    }

    updatePriority(companyId: ID, projectId: ID | null, manager: any, onSubmit: callback) {

        gd.modal.showForm({
            className: 'modal-bulk-priority',
            header: {
                title: 'Select Priority'
            },
            component: require('./bulk-action/update-priority/update-priority.jsx'),

            params: {
                onSubmit: onSubmit,
                companyId: companyId,
                projectId: projectId,
                manager: manager,
            }
        });

    }

    updateStatus(companyId:ID, projectId:ID|null, itemsGroupedByType:any, onSubmit:callback) {

        gd.modal.showForm({
            className: 'modal-bulk-status',
            header: {
                title: 'Update Status'
            },
            component: require('./bulk-action/update-status/update-status.jsx'),

            params: {
                onSubmit: onSubmit,
                companyId: companyId,
                projectId: projectId,
                itemsGroupedByType: itemsGroupedByType,
            }
        });

    }

    updateDeadline(buttons:any, onSubmit:callback) {
        gd.modal.showGeneric({
            className: 'modal-action-deadline',
            header: {
                title: 'Tasks Deadline'
            },
            component: require('./deadline-task/modal-action-deadline'),

            params: {
                onSubmit,
                btnUnset: buttons.unset,
            }
        });
    }

    updateStartDate(buttons:any, callback:callback) {
        gd.modal.showGeneric({
            className: 'modal-action-deadline',
            header: {
                title: 'Tasks start Date',
            },

            component: SelectDate,

            params: {
                onSubmit: (value:any)=>{
                    if (callback) callback(value);
                    gd.modal.hide();
                },
                minDate         : null,
                btnToday        : buttons.today,
                btnTomorrow     : buttons.tomorrow,
                btnNoValue      : buttons.unset,
                btnNoValueLabel : buttons.unsetLabel
            }
        });
    }

    updateEndDate(buttons:any, callback:any) {
        gd.modal.showGeneric({
            className: 'modal-action-deadline',
            header: {
                title: 'Tasks end Date',
            },

            component: SelectDate,

            params: {
                onSubmit: (value:any)=>{
                    if (callback) callback(value);
                    gd.modal.hide();
                },
                minDate         : null,
                btnToday        : buttons.today,
                btnTomorrow     : buttons.tomorrow,
                btnNoValue      : buttons.unset,
                btnNoValueLabel : buttons.unsetLabel
            }
        });
    }

    updateStartEndDate(buttons:any, callback:callback) {
        gd.modal.showGeneric({
            className: 'modal-action-date-range',
            header: {
                title: 'Start/End Date',
            },

            component: require('./select-date/select-date-range'),

            params: {
                onSubmit: (value:any)=>{
                    if (callback) callback(value);
                    gd.modal.hide();
                },
                btnNoValue      : buttons.unset,
                btnNoValueLabel : buttons.unsetLabel
            }
        });
    }

    updateDate(title:string, callback:callback) {
        gd.modal.showGeneric({
            // className: 'modal-action-deadline',
            header: {
                title,
            },

            component: SelectDate,

            params: {
                onSubmit: (value:any) => {
                    if (callback) callback(value);
                    gd.modal.hide();
                },
            }
        });
    }

    updateEstimate(callback:callback) {
        gd.modal.showGeneric({
            className: 'modal-action-estimate',
            header: {
                title: 'Tasks Estimate'
            },
            component: require('./estimate-task/modal-action-estimate'),
            params: {
                onSubmit: (values:any)=>{
                    const estimate = values.hours * 60 + values.minutes;
                    if (callback) callback(estimate);
                    gd.modal.hide();
                },
            }
        });
    }

    updateStoryPoints(callback:callback) {
        gd.modal.showGeneric({
            className: 'modal-action-story-points',
            header: {
                title: 'Tasks Story points'
            },
            component: require('./story-points/modal-action-story-points'),
            params: {
                onSubmit: (storyPoints:any)=>{
                    if (callback) callback(storyPoints);
                    gd.modal.hide();
                },
            }
        });
    }

    updateProgress(callback:callback) {
        gd.modal.showGeneric({
            className: 'modal-progress',
            component: require('./progress/progress'),
            header: {
                title: 'Tasks Progress'
            },
            params: {
                onSubmit: (value:any)=>{
                    if (callback) callback(value);
                    gd.modal.hide();
                }
            }
        });
    }

    updateCustomField(customFieldId:ID, callback:callback, options:any={}) {
        if (areCustomFieldsLocked()) {
            showCustomFieldsUpgrade()
            return
        }

        gd.modal.showForm({
            header: {
                title: 'Update'
            },
            component: require('./bulk-action/update-custom-field/update-custom-field'),
            params: {
                onSubmit: (newValue:any)=>{
                    if (callback) callback(newValue);
                    else gd.modal.hide();
                },
                customFieldId: customFieldId
            }
        });
    }

    deleteTasks(tasks:any[], callback?: callback) {
        const message = (
            <div>
                <div className="message">
                    <div className="txt">
                        Are you sure that you want to delete selected tasks?
                    </div>
                </div>
                <div className="comment">
                    All tasks data, attachments, subtasks and time reports will be deleted as well.
                </div>
            </div>
        )

        gd.modals.confirm.deleteMessage('Tasks', message, async ()=>{
            const response = await gd.api.BulkActions.deleteTasks(tasks).promise()
            gd.session.recent.tasks.tasksRemove(response)
            gd.modal.hide()
            callback?.(response)
        })
    }
}
